import type { CrmRecordsParams } from "app/pages/sales-intelligence/domain/crm-integration/types/records";

const BASE_QUERY_KEY = "crm-integration";
const DESCRIPTION_QUERY_KEY = "description";
const COMPANY_RECORDS_QUERY_KEY = "company-records";

export const crmIntegrationQueryKeys = {
    customFiltersDescription: () => [BASE_QUERY_KEY, DESCRIPTION_QUERY_KEY] as const,

    companyRecords: ({ domain, integrationProvider, dto }: CrmRecordsParams) =>
        [BASE_QUERY_KEY, COMPANY_RECORDS_QUERY_KEY, domain, integrationProvider, dto] as const,
};
